export default {
    COMPARISON_FILTER: 'comparison-filter',
    APPLY_FILTERS: 'filters-applied',
    CLEAR_SEGMENTS: 'clear-segments',
    CLEAR_FILTERS: 'clear-filters',
    TRIGGER_MAP_RATES_VISIBILITY: 'trigger-map-rates-visibility',
    TRIGGER_MAP_VISIBILITY: 'trigger-map-visibility',
    TRIGGER_FLIGHT_FILTERS: 'trigger-flight-filters',
    FLIGHT_FILTER_SEARCH_STARTED: 'flight-filter-search-started',
    FLIGHT_FILTER_SEARCH_ENDED: 'flight-filter-search-ended',
    MAP_SHOW_HIDE_RATES: 'MAP_SHOW_HIDE_RATES',
};



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/config/train-events.js